import { render, staticRenderFns } from "./ComplianceChoice.vue?vue&type=template&id=ea614608&"
import script from "./ComplianceChoice.vue?vue&type=script&lang=js&"
export * from "./ComplianceChoice.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceChoice.vue?vue&type=style&index=0&id=ea614608&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports